import { ApplicationFormValues } from '../../../../../LoanDetailTypes';
import { Rule } from '../../../interfaces/Rule';
import { Ruleset } from '../../../interfaces/Ruleset';
import {
  RulesetResult,
  IsPropertyLeased,
  IsPropertyOwnerAnotherIndividual,
} from '../../rules';
import IsPropertyLandlord from '../../rules/IsPropertyLandlord';
import { BaseRuleset } from '../BaseRuleset';

class PropertyOwnerFirstNameRuleset extends BaseRuleset implements Ruleset {
  protected rules: Rule[] = [
    IsPropertyLeased,
    IsPropertyOwnerAnotherIndividual,
  ];
  private index: number;

  public setIndex(index: number): PropertyOwnerFirstNameRuleset {
    this.index = index;
    return this;
  }

  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    const isLeased = IsPropertyLeased.evaluate(data);
    const isAnotherIndividual = IsPropertyOwnerAnotherIndividual.setIndex(
      this.index
    ).evaluate(data);
    const isLandlord = IsPropertyLandlord.setIndex(this.index).evaluate(data);

    return isLeased && isAnotherIndividual && isLandlord
      ? RulesetResult.REQUIRED
      : RulesetResult.HIDDEN;
  };
}

export default new PropertyOwnerFirstNameRuleset();
